import { render, staticRenderFns } from "./ErpIcmDbDataUse.vue?vue&type=template&id=1829effc&scoped=true&"
import script from "./ErpIcmDbDataUse.vue?vue&type=script&lang=js&"
export * from "./ErpIcmDbDataUse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1829effc",
  null
  
)

export default component.exports